import { SvgIcon } from '@mui/material'

export const MeetIcon = (props: any) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'white' }} {...props}>
    <path
      d="M17 14.4999V10.9999C17 10.7347 16.8946 10.4804 16.7071 10.2928C16.5196 10.1053 16.2652 9.99994 16 9.99994H4C3.73478 9.99994 3.48043 10.1053 3.29289 10.2928C3.10536 10.4804 3 10.7347 3 10.9999V20.9999C3 21.2652 3.10536 21.5195 3.29289 21.707C3.48043 21.8946 3.73478 21.9999 4 21.9999H16C16.2652 21.9999 16.5196 21.8946 16.7071 21.707C16.8946 21.5195 17 21.2652 17 20.9999V17.4999L21 21.4999V10.4999M3 3.85994L4.4 5.23994C7.5 2.18994 12.5 2.18994 15.6 5.23994L17 3.85994C13.14 0.0499415 6.87 0.0499415 3 3.85994ZM5.8 6.61994L7.2 7.99994C8.75 6.49994 11.25 6.49994 12.8 7.99994L14.2 6.61994C11.88 4.33994 8.12 4.33994 5.8 6.61994Z"
      fill="currentColor"
    />
  </SvgIcon>
)
